export default __webpack_public_path__ + "static/media/group-library.4c9d0caf.svg";